module.exports = __webpack_public_path__ + "img/bank-account-explanation.46431a98.jpg";